export function mapPostOptionsToFields (postOpts) {
  let fields = []
  for (let opt in postOpts) {
    if (opt === 'id') continue
    // Copy onto a fresh object. `Object.assign(postOpts[opt])` (single arg) returns the SAME object,
    // so the `delete formattedOpt.type` below mutated the source options in the store. On the getter's
    // next run `postOpts[opt].type` was already gone, the switch fell to default, and fieldType became
    // undefined — which dropped the 'date' fieldType from the bankrec start/end fields and made the
    // Statement Start/End Date inputs disappear. Copying keeps the mapping pure and idempotent.
    let formattedOpt = Object.assign({}, postOpts[opt])
    formattedOpt['name'] = opt
    switch (postOpts[opt].type) {
      case 'integer':
      case 'decimal':
        formattedOpt['fieldType'] = 'input'
        break
      case 'field':
        if (postOpts[opt].choices && postOpts[opt].choices.length) {
          formattedOpt['fieldType'] = 'select'
        } else {
          formattedOpt['fieldType'] = 'input'
          formattedOpt['autocomplete'] = true
          formattedOpt['searchAsync'] = true
          formattedOpt['triggerOnFocus'] = false
        }
        break
      default:
        formattedOpt['fieldType'] = postOpts[opt].type
    }
    delete formattedOpt.type
    fields.push(formattedOpt)
  }
  return fields
}
